// UI texts: survivor creation on one screen (route /start, docs/onboarding.md) and the
// one-time look picker for survivors from before section 8.
export default {
  docTitle: 'Create your survivor · AFTER DAY',
  back: 'Back to the start page',
  title: 'Who walks out?',
  sub: 'You can change your build and your name later. Your look stays.',
  /** Look picker for old survivors. */
  continue: 'Continue',
  chosen: 'Chosen',
  look: {
    label: 'Look',
    male: 'Male',
    female: 'Female',
    legacy: 'New: survivors now have a face. Pick one — you choose once.',
  },
  name: {
    /** 20. 10. 2026 (owner): the field is highlighted, with a suggested name that is easy to change. */
    label: 'Name your survivor',
    suggested: 'A suggested name. Make it yours: type over it or roll another.',
    placeholder: 'Survivor name',
    random: 'Random',
    randomTip: 'Random name',
    rule: '{min}–{max} characters: letters, numbers, spaces, - and _',
    err: {
      short: 'At least 3 characters.',
      long: 'At most 16 characters.',
      chars: 'Letters, numbers, spaces, - and _ only.',
      letter: 'Use at least one letter.',
      profanity: 'That name is not allowed. Try another.',
    },
  },
  bg: {
    label: 'Background',
    /** 10. 10. 2026 (owner): the small skill tree map. */
    treeNear: 'Your skill tree starts here, next to {sectors}.',
    treeAria: 'The skill tree: {name} starts next to {sectors}.',
    and: ' and ',
    /** 10. 10. 2026 (owner): before Walk out. */
    note: 'Your background sets where your skill tree begins. You can choose again at the start of each season.',
  },
  gear: {
    label: 'Starting gear',
  },
  figureAlt: '{name}, your survivor',
  walkOut: 'Walk out',
  walking: 'Walking out…',
  out: '{name} is out there',
  /** Krug 5 (K17): the first two runs cost no energy. */
  firstRun: 'First run: {zone} · {min} · free',
  /** 29. 9. 2026: a saved survivor on a new device, before a new one is made. */
  haveOne: 'Already have a survivor?',
  logIn: 'Log in',
  err: {
    offline: 'Could not reach the server. Try again.',
  },
} as const;
